<h3 mat-dialog-title>{{ 'devicesStatuses' | translate }} {{ data.sideNumber }}</h3>
<div mat-dialog-content>
  <app-vehicle-layout-view #vehicleLayoutView [additionalInfoImpls]="additionalInfoImpls" [editableMode]="false"></app-vehicle-layout-view>
  </div>
<div mat-dialog-content [ngStyle]="{ 'height.px': height, 'min-height': '20vh'}">
  <app-prime-table #table [showPagination]="false" [expandableDeviceStatusRow]="true" remoteDataType="websocket"></app-prime-table>
</div>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'close' | translate }}</button>
</mat-dialog-actions>